// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgPlane = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2a.75.75 0 0 1 .53.22l.829.828a4.75 4.75 0 0 1 1.391 3.359v1.351l4.825 2.316a.75.75 0 0 1 .425.676v1.327a1.75 1.75 0 0 1-2.027 1.728l-3.223-.515v1.824l.864.48a.75.75 0 0 1 .386.656v1a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-1a.75.75 0 0 1 .415-.67l.835-.418v-1.873l-3.224.516A1.75 1.75 0 0 1 2 12.077V10.75a.75.75 0 0 1 .425-.676L7.25 7.758V6.407c0-1.26.5-2.468 1.391-3.359l.829-.828A.75.75 0 0 1 10 2Zm0 1.81-.298.299a3.25 3.25 0 0 0-.952 2.298V8.23a.75.75 0 0 1-.425.676L3.5 11.222v.855a.25.25 0 0 0 .29.247l4.092-.655a.75.75 0 0 1 .868.741v3.215a.75.75 0 0 1-.415.67l-.408.205h4.229l-.52-.289a.75.75 0 0 1-.386-.655V12.41a.75.75 0 0 1 .868-.74l4.092.654a.25.25 0 0 0 .29-.247v-.855l-4.825-2.316a.75.75 0 0 1-.425-.676V6.407a3.25 3.25 0 0 0-.952-2.298L10 3.81Z"
    />
  </svg>
)

export default SvgPlane
